import { Modal } from 'react-bootstrap'

function ModalStockAdjustment({ children, ...props }) {
  const { title, size, backdrop = 'static' } = props
  return (
    <Modal
      {...props}
      centered
      scrollable
      size={size || 'sm'}
      backdrop={backdrop}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}
export default ModalStockAdjustment
